(() => {
  'use strict';
  if (customElements.get('shesh-collection-colors')) return;
  const palette = {
    'בג׳':'#d7c4ab','בג\'':'#d7c4ab','בג':'#d7c4ab',
    'כחול נייבי':'#20283e','כחול רויאל':'#2446bd','כחול כהה':'#20283e','כחול בהיר':'#9ebedc',
    'ורוד עתיק':'#c9959e','ורוד בהיר':'#f0ccd4','ירוק זית':'#777c49','ירוק בקבוק':'#244d3b',
    'חום שוקולד':'#54372d','שחור לבן':'linear-gradient(90deg,#222 50%,#fff 50%)',
    'לבן שבור':'#f3eee4','שמנת':'#f3eee4','שחור':'#191919','לבן':'#fff','סגול':'#882877',
    'בורדו':'#722f40','ורוד':'#e5a6bd','צהוב':'#f0dc94','חום':'#704d3a','מנטה':'#abd5c0',
    'לילך':'#c5afd6','תכלת':'#add2e5','אדום':'#ba3038','ירוק':'#4b755a','כחול':'#3a6299',
    'כתום':'#df894d','אפרסק':'#edb59f','בז׳':'#d7c4ab','בז\'':'#d7c4ab','בז':'#d7c4ab',
    'ניוד':'#dac0b0','נייבי':'#20283e','זהב':'#c6aa66','כסף':'#bfc2c5','אפור':'#929292',
    'טורקיז':'#62acae','פוקסיה':'#cb3a8a','אבן':'#d4cbbf','קרם':'#f1e7ce','שמפניה':'#e5d4ae',
    'זית':'#777c49','קאמל':'#b78c62','שוקולד':'#54372d','חציל':'#5b324f','פיסטוק':'#c1c997',
    'black':'#191919','white':'#fff','pink':'#e5a6bd','blue':'#3a6299','brown':'#704d3a',
    'red':'#ba3038','green':'#4b755a','yellow':'#f0dc94','purple':'#882877','navy':'#20283e'
  };
  const suffixes = Object.keys(palette).sort((a,b) => b.length-a.length);
  const normalize = title => String(title || '').normalize('NFKC').trim().replace(/\s+/g,' ').toLowerCase();
  function modelOf(title) {
    const normalized = normalize(title);
    for (const color of suffixes) {
      if (normalized.endsWith(' '+color)) {
        return {model:normalized.slice(0,-color.length).replace(/[\s\-–—|]+$/g,''),color};
      }
    }
    return {model:normalized,color:null};
  }
  const cache = new Map();
  const waiting = [];
  let active = 0;
  function pump() {
    while (active < 3 && waiting.length) {
      const next = waiting.shift(); active++;
      next().finally(() => {active--;pump();});
    }
  }
  function findColors(model,searchUrl) {
    const key = searchUrl+'|'+model;
    if (!cache.has(key)) {
      cache.set(key,new Promise(resolve => {
        waiting.push(async () => {
          try {
            const url = new URL(searchUrl,location.origin);
            const escaped = model.replace(/\\/g,'\\\\').replace(/"/g,'\\"');
            url.searchParams.set('q','title:"'+escaped+'"');
            url.searchParams.set('type','product');
            url.searchParams.set('options[prefix]','none');
            url.searchParams.set('options[unavailable_products]','show');
            url.searchParams.set('view','shesh-color-options');
            const response = await fetch(url.href,{credentials:'same-origin'});
            if (!response.ok) throw new Error('Color lookup unavailable');
            const data = await response.json();
            resolve((data.products || []).filter(product => modelOf(product.title).model === model));
          } catch (_) {resolve([]);}
        });
        pump();
      }));
    }
    return cache.get(key);
  }
  function safeUrl(value) {
    try {const url=new URL(value,location.origin);return url.origin===location.origin?url:null;}
    catch (_) {return null;}
  }
  class SheshCollectionColors extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      const parsed = modelOf(this.dataset.title);
      if (!/^שמלת?\s/.test(parsed.model)) return;
      this.model = parsed.model;
      if (observer) observer.observe(this.parentElement);
      else this.loadColors();
    }
    disconnectedCallback() {if(observer && this.parentElement) observer.unobserve(this.parentElement);}
    async loadColors() {
      const products = await findColors(this.model,this.dataset.searchUrl);
      if (!this.isConnected) {this.started=false;return;}
      const seen = new Set();
      const colors = products.filter(product => {
        const color = modelOf(product.title).color || normalize(product.title);
        if(seen.has(color) || !safeUrl(product.url)) return false;
        seen.add(color);return true;
      });
      if (colors.length < 2 || !colors.some(p => String(p.id)===this.dataset.productId)) return;
      const list=document.createElement('ul');
      list.className='SheshColors';list.setAttribute('aria-label',this.dataset.label);list.setAttribute('role','list');
      colors.forEach(product => {
        const color=modelOf(product.title).color;
        const li=document.createElement('li');
        const link=document.createElement('a');link.className='SheshColors__Link';
        link.href=safeUrl(product.url).href;link.title=product.title;link.setAttribute('aria-label',product.title);
        if(String(product.id)===this.dataset.productId) link.setAttribute('aria-current','page');
        const dot=document.createElement('span');dot.className='SheshColors__Dot';dot.setAttribute('aria-hidden','true');
        if(color) dot.style.setProperty('--shesh-color',palette[color]);
        else if(product.image) {
          const imageUrl=new URL(product.image,location.origin);
          if(imageUrl.protocol==='https:') {
            const image=document.createElement('img');image.src=imageUrl.href;image.alt='';image.loading='lazy';image.width=24;image.height=24;dot.append(image);
          }
        }
        link.append(dot);li.append(link);list.append(li);
      });
      this.replaceChildren(list);this.hidden=false;
    }
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        observer.unobserve(entry.target);
        const colors=entry.target.querySelector('shesh-collection-colors');
        if(colors) colors.loadColors();
      }
    });
  },{rootMargin:'300px'}) : null;
  customElements.define('shesh-collection-colors',SheshCollectionColors);
})();
